import React from "react";
import l from "components/util/l";

const RevisionAdditionalComments = ({
  allowComments,
  globalAdditionalComments,
  onChangeGlobalAdditionalComments,
  onClickSaveRevision,
  isSaving,
}) => {
  return (
    <div
      className="h-auto h-md-100 col-12 col-md-6 rounded bg-white d-flex flex-column align-items-center justify-content-center p-5 overflow-auto"
    >
      <div className="w-100" style={{ maxWidth: "35rem" }}>

        <div className="mb-4 text-center">
          <i className="fas fa-comment-dots fa-3x text-primary mb-3 opacity-50"></i>
          <h3 className="font-weight-bold">{l("Comentarios Adicionales%PA433")}</h3>
        </div>

        {allowComments &&
          <textarea
            className="form-control shadow-sm bg-light p-4"
            style={{ minHeight: "180px", whiteSpace: "pre-wrap", resize: "vertical" }}
            value={globalAdditionalComments || ""}
            onChange={(event) => onChangeGlobalAdditionalComments(event.target.value)}
          />
        }

      </div>
    </div>
  );
};

export default RevisionAdditionalComments;
